'use client'

import { Button, html } from '@ensemble.music/ui'
import { Cookie } from 'lucide-react'
import { useEffect, useState } from 'react'
import { useCookieConsent } from '../../hooks/useCookieConsent'

export const CookieBanner = () => {
  const { hasGivenAction, giveDiscent, giveConsent } = useCookieConsent()
  // the consent lives in a cookie, which the server cannot read while rendering, so the banner
  // only mounts on the client - otherwise the markup would not match after hydration
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  if (!isClient || hasGivenAction) return null

  return (
    <html.aside
      role="region"
      aria-label="Cookie-Hinweis"
      className="fixed left-4 bottom-4 z-48 flex flex-col gap-3 w-[360px] max-sm:right-4 max-sm:w-auto bg-surface border border-border-color rounded-card shadow-lg p-4"
    >
      <html.div className="flex flex-col gap-2">
        <html.h2 className="flex flex-row items-center gap-2 text-base font-semibold text-color">
          <Cookie
            size={20}
            aria-hidden="true"
            className="text-primary"
          />
          Cookies
        </html.h2>
        <html.p className="text-sm text-color-secondary">
          Notwendige Cookies brauchen wir immer, Analyse-Cookies nur mit deiner Einwilligung. Mehr
          in der{' '}
          <html.a
            href="/datenschutz"
            className="text-link hover:underline"
          >
            Datenschutzerklärung
          </html.a>
          .
        </html.p>
      </html.div>
      <html.div className="flex flex-row flex-wrap justify-end gap-2">
        <Button
          type="button"
          tone="secondary"
          onClick={() => giveDiscent()}
        >
          Nur notwendige
        </Button>
        <Button
          type="button"
          onClick={() => giveConsent()}
        >
          Alle akzeptieren
        </Button>
      </html.div>
    </html.aside>
  )
}
